var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMultiWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 32,
    viewBox: "0 0 29 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 8.18577V3.81399C11 3.2319 10.6857 2.69459 10.1729 2.40558L6.32707 0.219687C5.81429 -0.0693227 5.18571 -0.0693227 4.67293 0.219687L0.827068 2.40558C0.314286 2.69459 0 3.2319 0 3.81399V8.18577C0 8.76786 0.314286 9.30517 0.827068 9.59418L4.67293 11.7801C5.18571 12.0691 5.81429 12.0691 6.32707 11.7801L10.1729 9.59418C10.6857 9.30517 11 8.76786 11 8.18577Z",
    fill: "black"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip1_4_16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 28.1858V23.814C11 23.2319 10.6857 22.6946 10.1729 22.4056L6.32707 20.2197C5.81429 19.9307 5.18571 19.9307 4.67293 20.2197L0.827068 22.4056C0.314286 22.6946 0 23.2319 0 23.814V28.1858C0 28.7679 0.314286 29.3052 0.827068 29.5942L4.67293 31.7801C5.18571 32.0691 5.81429 32.0691 6.32707 31.7801L10.1729 29.5942C10.6857 29.3052 11 28.7679 11 28.1858Z",
    fill: "black"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    clipPath: "url(#clip2_4_16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 8.18577V3.81399C29 3.2319 28.6857 2.69459 28.1729 2.40558L24.3271 0.219687C23.8143 -0.0693227 23.1857 -0.0693227 22.6729 0.219687L18.8271 2.40558C18.3143 2.69459 18 3.2319 18 3.81399V8.18577C18 8.76786 18.3143 9.30517 18.8271 9.59418L22.6729 11.7801C23.1857 12.0691 23.8143 12.0691 24.3271 11.7801L28.1729 9.59418C28.6857 9.30517 29 8.76786 29 8.18577Z",
    fill: "black"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_4_16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 28.1858V23.814C29 23.2319 28.6857 22.6946 28.1729 22.4056L24.3271 20.2197C23.8143 19.9307 23.1857 19.9307 22.6729 20.2197L18.8271 22.4056C18.3143 22.6946 18 23.2319 18 23.814V28.1858C18 28.7679 18.3143 29.3052 18.8271 29.5942L22.6729 31.7801C23.1857 32.0691 23.8143 32.0691 24.3271 31.7801L28.1729 29.5942C28.6857 29.3052 29 28.7679 29 28.1858Z",
    fill: "black"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4_4_16049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 18.1858V13.814C20 13.2319 19.6857 12.6946 19.1729 12.4056L15.3271 10.2197C14.8143 9.93068 14.1857 9.93068 13.6729 10.2197L9.82707 12.4056C9.31429 12.6946 9 13.2319 9 13.814V18.1858C9 18.7679 9.31429 19.3052 9.82707 19.5942L13.6729 21.7801C14.1857 22.0691 14.8143 22.0691 15.3271 21.7801L19.1729 19.5942C19.6857 19.3052 20 18.7679 20 18.1858Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_16049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4_16049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(0 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_4_16049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(18)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_4_16049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(18 20)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4_4_16049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 12,
    fill: "white",
    transform: "translate(9 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiWarehouse);
export default __webpack_public_path__ + "static/media/multi-warehouse.c150814d67e19bde91eee0f12561beed.svg";
export { ForwardRef as ReactComponent };